/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { TimesheetsService } from 'app/core/services/timesheets/timesheets.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import moment, { Moment } from 'moment';

@Component({
  selector: 'app-view-history',
  templateUrl: './view-history.component.html',
  styleUrls: ['./view-history.component.scss']
})
export class ViewHistoryComponent implements OnInit {

  searchDate: any = moment();
  dateFormat: any = 'YYYY-MM-DD';
  today: any = moment();


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewHistoryComponent>,
    public _utilityService: UtilityService,
    private _dataCollectorService: DataCollectorService,
    private _timesheetService: TimesheetsService
  ) { }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if ((moment(cellDate).date() === 1) &&
        (view === 'month')
       )
    {
       this.changeMonth(cellDate);
    };
    return '';
  };

  changeMonth(date: any): void {
    this.getTimesheetAvailability(date);
  }

  getTimesheetAvailability(date: Moment): void {
    const filter = {
      'from_date': date.startOf('month').format('YYYY-MM-DD'),
      'to_date': date.endOf('month').format('YYYY-MM-DD'),
      'user_uid': this.data?.data?.user?.user_uid
    };

    this._dataCollectorService.getData(this._timesheetService.historyAvailabilityUrl, filter)
      .subscribe((res: any) => {
        const allCellContent = document.querySelectorAll('.mat-calendar-body-cell-content');
        allCellContent.forEach((cell: any) => {
          const found = res?.data.findIndex((data: any) => (moment(data, 'YYYY-MM-DD').format('D') === cell.innerText));
          if(found > -1){
              cell.classList.add('route-available');
            }else{
              cell.classList.remove('route-available');
          }
        });
      });
  }

  selectDate(): void {
    this.dialogRef.close(this.searchDate);
  }

  ngOnInit(): void {
    this.dateFormat = this._utilityService.dateFormat;
  }

}
